/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-new */

import React, { useEffect, useState, } from 'react';
import {
    Typography,
    Menu,
    Space,
    Dropdown,
    Button,
} from 'antd';
import { DownOutlined, } from '@ant-design/icons';
import Constant from '../../Global/Constant';

function GTranslate() {
    const languages: Record<string, string> = Constant.languageMap;
    const includedLanguages = Object.keys(languages).join(',');
    const pageLanguage = localStorage.getItem('selectedLanguage');
    const [language, setLanguage] = useState(
        pageLanguage ? languages[pageLanguage] : 'EN'
    );

    const handleClick = (e: any) => {
        const selectElement = document.querySelector(
            '.goog-te-combo'
        ) as HTMLSelectElement;

        setLanguage(languages[e.key]);
        localStorage.setItem('selectedLanguage', e.key);
        const optionToSelect = selectElement.querySelector(
            `option[value="${e.key}"]`
        ) as HTMLOptionElement;
        if (optionToSelect) {
            optionToSelect.selected = true;
            selectElement.dispatchEvent(new Event('change', { bubbles: true }));
        }
    };

    const menuItems = (
        <Menu className="notranslate" onClick={handleClick}>
            <Menu.Item key="en">
                <Typography>EN</Typography>
            </Menu.Item>
            <Menu.Item key="ar">
                <Typography>AR</Typography>
            </Menu.Item>
        </Menu>
    );

    const googleTranslateElementInit = () => {
        new (window as any).google.translate.TranslateElement(
            {
                includedLanguages,
                autoDisplay: false,
            },
            'google_translate_element'
        );
    };

    useEffect(() => {
        if (!document.getElementById(Constant.googleScriptId)) {
            const addScript = document.createElement('script');
            addScript.id = Constant.googleScriptId;
            addScript.src = Constant.googleTranslateUrl;
            document.body.appendChild(addScript);
            (window as any).googleTranslateElementInit = googleTranslateElementInit;
        }
    }, []);

    return (
        <Dropdown overlay={menuItems}>
            <Button type="text">
                <Space>
                    {language} <DownOutlined />
                </Space>
            </Button>
        </Dropdown>
    );
}

export default GTranslate;
